import React from 'react';
import PropTypes from 'prop-types';
import StyledTextField from '../common/StyledTextField';
import PasswordInput from '../PasswordInput';
function SignInForm(_ref) {
  var signInPath = _ref.signInPath,
    csrfToken = _ref.csrfToken,
    invitedEmail = _ref.invitedEmail,
    submitId = _ref.submitId,
    newPasswordPath = _ref.newPasswordPath,
    showRegisterLinks = _ref.showRegisterLinks,
    employerRegistrationPath = _ref.employerRegistrationPath,
    consultantRegistrationPath = _ref.consultantRegistrationPath,
    children = _ref.children;
  return /*#__PURE__*/React.createElement("div", {
    className: "signin"
  }, /*#__PURE__*/React.createElement("form", {
    method: "POST",
    action: signInPath,
    id: "sign-in-form"
  }, /*#__PURE__*/React.createElement("input", {
    type: "hidden",
    name: "authenticity_token",
    value: csrfToken
  }), children, /*#__PURE__*/React.createElement(StyledTextField, {
    id: "email",
    className: "form-control fs-hide validate",
    name: "user[email]",
    label: "Email",
    type: "email",
    defaultValue: invitedEmail,
    margin: "normal",
    required: true
  }), /*#__PURE__*/React.createElement(PasswordInput, {
    errors: false,
    title: "Password",
    tabIndex: "0",
    type: "sign-in"
  }), newPasswordPath && /*#__PURE__*/React.createElement("div", {
    className: "row small-text"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-xs-12 forgot-password"
  }, /*#__PURE__*/React.createElement("a", {
    href: newPasswordPath
  }, "Don't have your password?"))), /*#__PURE__*/React.createElement("input", {
    type: "submit",
    className: "btn btn-primary full-width sign-in-button",
    id: submitId,
    value: "Sign in",
    tabIndex: "0"
  }), showRegisterLinks && /*#__PURE__*/React.createElement("div", {
    className: "register-links"
  }, "Don't have an account?", /*#__PURE__*/React.createElement("a", {
    href: employerRegistrationPath
  }, "Sign Up as an Employer"), "or", /*#__PURE__*/React.createElement("a", {
    href: consultantRegistrationPath
  }, "Join as a Consultant"))));
}
SignInForm.propTypes = {
  signInPath: PropTypes.string.isRequired,
  csrfToken: PropTypes.string.isRequired,
  invitedEmail: PropTypes.string,
  newPasswordPath: PropTypes.string,
  showRegisterLinks: PropTypes.bool,
  employerRegistrationPath: PropTypes.string,
  consultantRegistrationPath: PropTypes.string,
  submitId: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)])
};
SignInForm.defaultProps = {
  invitedEmail: null,
  newPasswordPath: null,
  showRegisterLinks: false,
  employerRegistrationPath: null,
  consultantRegistrationPath: null,
  submitId: 'sign-in',
  children: null
};
export default SignInForm;